window.config = {
  webPath: '',

  itradeAPI: '',
  itradePath: '',

  // en_US 英 zh_CN 简 zh_TW 繁
  defaultLanguage: 'zh_CN', 

  companyOptions: {
    trading: {
      autoRefreshOrderEnquiry: 5000,
      autoCheckSession: 300000
    }
  }
}